/* eslint-disable */
import Vue from 'vue';
import Router from 'vue-router';
import AuthServices from '../app/auth-services';
import store from '../store/index';
import { Hub } from 'aws-amplify';
import Home from '@/components/Home';
import SignIn from '@/components/SignIn';
import SignInNickname from '@/components/SignInNickname';

Vue.use(Router)

export default new Router({
    mode: 'history',
    base: '/',
    routes: [
        {
            path: '/',
            name: 'Home',
            component: Home,
            async beforeEnter(to, from, next) {

                //console.log("from.query", from.query, JSON.stringify(from.query))
                //console.log("to.query", to.query, JSON.stringify(to.query))

                let isLoggedIn = await AuthServices.isLoggedIn();
                if (!isLoggedIn) {
                    store.dispatch('setLoggedOut');
                    store.dispatch('setInitialQuery', JSON.stringify(to.query));
                    next({ name: 'Login' });
                }
                else {
                    //NOTA si � corretto che sia in entrabi i rami dell'if....
                    store.dispatch('setInitialQuery', JSON.stringify(to.query));

                    let user = await AuthServices.getCurrentAuthUser();
                    let token = user.getSignInUserSession().getIdToken().jwtToken;
                    let userData = AuthServices.getDecodedSessionToken(token)
                    let hasValidConfirmedAttribute = await AuthServices.getCurrentAuthUserInfo_Confirmed()
                    //console.log("hasValidConfirmedAttribute", hasValidConfirmedAttribute)

                    if (!hasValidConfirmedAttribute) {
                        //redirect to complete registration
                        let redirectUrl = new URL(process.env.VUE_APP_COMPLETE_REGISTRATION_URL)
                        redirectUrl.searchParams.append('sub', userData.sub);
                        redirectUrl.searchParams.append('email', userData.email);
                        //redirectUrl.searchParams.append('exhibitionId', process.env.VUE_APP_EXHIBITION_ID);
                        redirectUrl.searchParams.append('callback', window.location.origin);
                        //console.log("redirectUrl.href", redirectUrl.href)
                        window.location.href = redirectUrl.href;
                        return;
                    }

                    store.dispatch('setLoggedIn', true);
                    store.dispatch('setInitialToken', token);                    
                    next();
                }
            }
        },
        {
            path: '/login',
            name: 'Login',
            component: SignIn,
        },
        {
            path: '/login-nickname',
            name: 'LoginNickname',
            component: SignInNickname,
        },
        {
            path: '/login/oauth2/code/cognito',
            name: 'ExternalLogin',
            async beforeEnter(to, from, next) {
                Hub.listen('auth', async ({ payload: { event, data } }) => {
                    //console.log('***** ExternalLogin auth listener', event)
                    switch (event) {
                        case 'signIn': //case 'cognitoHostedUI'
                            //let param = store.getters.initialQuery;
                            //next({ name: 'Home', params: param, replace: true });
                            store.dispatch('getNickname');
                            break;
                        case 'signOut':
                            store.dispatch('setLoggedOut', true);
                            break;
                        case 'signIn_failure': //case 'cognitoHostedUI_failure':
                            console.log('AB - Sign in failure', data);
                            next({ name: 'Logout' });
                            break;
                    }
                });
            }
        },
        {
            path: '/logout',
            name: 'Logout',
            async beforeEnter(to, from, next) {
                await AuthServices.signOut();
                store.dispatch('setLoggedOut');
                next({ name: 'Login' });
            }
        },
        {
            path: '/error',
            name: 'Error',
            //component: ErrorComponent,
            //beforeEnter(to, from, next) {
            //    next();
            //}
        }

    ]
})